import { ArrowRight } from "lucide-react";

export function Footer({ onBook }: { onBook: () => void }) {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-inner">
          <div className="footer-brand">
            <a href="#top" className="logo">
              <img src="/logo-master.png" alt="" />
              <span>
                Automate<em>828</em>
              </span>
            </a>
            <p>
              Business automation, grounded in the Blue Ridge. We use AI to move
              faster. A human is always at the wheel.
            </p>
          </div>
          <div className="footer-col">
            <h5>What we do</h5>
            <ul>
              <li><a href="#services">New software</a></li>
              <li><a href="#modernize">Legacy migrations</a></li>
              <li><a href="#services">Cloud moves</a></li>
              <li><a href="#services">Databases</a></li>
              <li><a href="#services">Scripts &amp; integrations</a></li>
              <li><a href="#mail">Print &amp; mail</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h5>The shop</h5>
            <ul>
              <li><a href="#process">How we work</a></li>
              <li><a href="#scenarios">Scenarios</a></li>
              <li><a href="#local">The 828</a></li>
              <li><a href="#ai">On AI</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h5>Reach us</h5>
            <ul>
              <li>
                <button
                  type="button"
                  className="footer-cta-link"
                  onClick={onBook}
                >
                  Book a free intro
                  <ArrowRight size={14} />
                </button>
              </li>
              <li>Hendersonville, NC</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {year} Automate828, LLC</span>
          <span>Built in the 828 · est. 2024</span>
        </div>
      </div>
    </footer>
  );
}
